<template>
  <div>
    <CommonExpansionPanel>
      <template v-slot:title-panel>
        Datos de contacto
      </template>
      <v-expansion-panel-content>
        <ViewContactData @changeComponent="switch_data = 2" :clienteInfo="clienteInfo" :canEdit="canEdit"
          v-if="switch_data == 1">
        </ViewContactData>
        <EditContactData @changeTab="switch_data = 1" @getData="$emit('getData'), switch_data = 1"
          :clienteInfo="clienteInfo" v-else>
        </EditContactData>
      </v-expansion-panel-content>
    </CommonExpansionPanel>
  </div>
</template>

<script>
import CommonExpansionPanel from "@/components/commonComponents/CommonExpansionPanel.vue";
import ViewContactData from "./ViewContactData.vue";
import EditContactData from "./EditContactData.vue";

export default {
  components: {
    CommonExpansionPanel,
    ViewContactData,
    EditContactData,
  },
  props: {
    clienteInfo: Object,
    canEdit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      switch_data: 1,
    };
  },

  methods: {
    changeComponent(component) {
      this.switch_data = component;
    },
  },
};
</script>
